export default "__VITE_ASSET__BgcUFApK__"